import { create } from "zustand";
import { persist } from "zustand/middleware";

interface TimeRangeState {
  rangeStart: Date;
  rangeEnd: Date;
  setTimeRange: (start: Date, end: Date) => void;
  getDefaultWeekRange: (centerTime: Date) => { start: Date; end: Date };
}

export const useScheduleTimeRange = create(
  persist<TimeRangeState>(
    (set, get) => ({
      // Default to a week range centered on current time
      rangeStart: (() => {
        const start = new Date();
        start.setDate(start.getDate() - 3);
        start.setHours(0, 0, 0, 0);
        return start;
      })(),
      rangeEnd: (() => {
        const end = new Date();
        end.setDate(end.getDate() + 4);
        end.setHours(23, 59, 59, 999);
        return end;
      })(),

      setTimeRange: (start: Date, end: Date) => {
        set({ rangeStart: start, rangeEnd: end });
      },

      getDefaultWeekRange: (centerTime: Date) => {
        const start = new Date(centerTime);
        start.setDate(start.getDate() - 3);
        start.setHours(0, 0, 0, 0);

        const end = new Date(centerTime);
        end.setDate(end.getDate() + 4);
        end.setHours(23, 59, 59, 999);

        return { start, end };
      },
    }),
    {
      name: "schedule-time-range-storage",
      // Custom serialization to handle Date objects
      storage: {
        getItem: (name) => {
          const str = localStorage.getItem(name);
          if (!str) return null;
          const data = JSON.parse(str);
          return {
            ...data,
            state: {
              ...data.state,
              rangeStart: new Date(data.state.rangeStart),
              rangeEnd: new Date(data.state.rangeEnd),
            },
          };
        },
        setItem: (name, value) => {
          localStorage.setItem(name, JSON.stringify(value));
        },
        removeItem: (name) => {
          localStorage.removeItem(name);
        },
      },
    }
  )
);